import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

enum CURRENCIES {
    BGN = 'BGN',
    EUR = 'EUR',
}

type CellPriceProps<TData, TValue> = CellContext<TData, TValue> & {
    currency?: CURRENCIES;
};

export function CellPrice<TData, TValue>({ getValue, currency = CURRENCIES.BGN }: CellPriceProps<TData, TValue>) {
    const value = getValue() as number;
    const { formatNumber } = useIntl();
    if (value == null) return '-';

    return (
        <span>
            {formatNumber(value / 100, {
                style: 'currency',
                currency: currency,
            })}
        </span>
    );
}
